import styled from "styled-components";
import variables from "styles/base/_universal.scss";

export const ToolTipText = styled.div`
  font-size: ${variables.fontSmall};
  color: ${variables.gray30Color};
`;
